import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkme { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '群組代號 (ME001) 不可空白'}) 
    @MaxLength(6,{message: '群組代號 (ME001) 資料太長'})
    ME001: string = '';            // 群組代號 6 STKPI13  HAND:STKMH

    @MaxLength(10,{message: '群組名稱 (ME002) 資料太長'})
    ME002: string = '';            // 群組名稱 10 

    @MaxLength(255,{message: '備註 (ME003) 資料太長'})
    ME003: string = '';            // 備註 255 

    @IsNumber() 
    ME004: number = 99;            // 排序碼 4 [DEF:99]

    @MaxLength(1,{message: '更新碼 (ME005) 資料太長'})
    ME005: string = 'Y';            // 更新碼 1 [DEF:"Y"]

    @IsNumber() 
    ME006: number = 0;            // 平均漲幅 8.4 

    @IsNumber() 
    ME007: number = 0;            // 前1/3漲跌幅% 8.4 

    @IsNumber() 
    ME008: number = 0;            // 末1/3漲跌幅% 8.4 

    @IsNumber() 
    ME009: number = 0;            // 最大漲幅% 8.4 

    @MaxLength(8,{message: '更新時間 (ME010) 資料太長'})
    ME010: string = '';            // 更新時間 8 hh:mm:ss 以呼叫時間為準

    @IsNumber() 
    ME011: number = 0;            // 趨勢 8 

    @IsNumber() 
    ME012: number = 0;            // 漲幅超過N%通知 6.3 

    @MaxLength(1,{message: '熱力圖分析 (ME013) 資料太長'})
    ME013: string = 'N';            // 熱力圖分析 1 [DEF:"N"]

    @MaxLength(6,{message: '條件代號 (ME014) 資料太長'})
    ME014: string = '';            // 條件代號 6 


}
